export const useSxStyles = () => {
  return {
    labelReadMode: {
      width: '150px',
      lineHeight: '19px',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    table: {
      marginTop: '10px',
      borderCollapse: 'separate',
      borderSpacing: '0px 4px',
    },
    valReadMode: {
      fontSize: '13px',
    },
  };
};
